import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@app/services/auth.service';
import {
    LOCAL_STORAGE_KEY,
    StorageService,
} from '@app/services/storage.service';
import { ROUTE_PATH } from '../enum/common.enum';

export const resetPasswordGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const storageService = inject(StorageService);
    const router = inject(Router);

    const currentUser = JSON.parse(
        storageService.getItem(LOCAL_STORAGE_KEY.USER_ID)!
    );

    const isPasswordChanged = JSON.parse(
        storageService.getItem(LOCAL_STORAGE_KEY.IS_PASSWORD)!
    );
    if (
        authService.isAuthenticated() &&
        !currentUser.is_password_changed &&
        !isPasswordChanged
    ) {
        return true;
    } else if (storageService.getItem(LOCAL_STORAGE_KEY.TEMP_TOKEN) !== null) {
        router.navigate([ROUTE_PATH.OTP]);
        return false;
    } else {
        router.navigate([ROUTE_PATH.DASHBOARD]);
        return false;
    }
};
